var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Anchor, Container, Grid, GridColumn, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import config from '../Config';
import { createGaEvent } from '../util/GaUtil';
import customerIdAsKey from './customerIdAsKey';
import { injectStores } from '../util/StoresUtil';
let DiilCustomerRequiredNotice = class DiilCustomerRequiredNotice extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "representationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sendGaData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (eventLabel) => {
                createGaEvent({
                    eventCategory: 'Iseteenindus - Avaleht',
                    eventAction: 'Top Alert - Jätkemiseks vahenda esindatav',
                    eventLabel
                });
            }
        });
        Object.defineProperty(this, "handleClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                createGaEvent({
                    eventCategory: 'Iseteenindus - Avaleht',
                    eventAction: 'Top Alert - Jätkamiseks vaheta esindatav',
                    eventLabel: 'Vaheta esindatav'
                });
                event.preventDefault();
                this.ssoStore.openSsoFrame();
            }
        });
    }
    componentDidMount() {
        return this.representationStore.fetchAccountsAndProductsExistence();
    }
    render() {
        const { translate } = this.translateStore;
        const mandateOrServicesRequiredTranslation = !this.representationStore.hasDiilAccounts
            ? translate('customerNotice.mandates-required')
            : translate('customerNotice.products-required');
        if (!this.representationStore.showNotice || this.representationStore.isLoading || this.representationStore.hasFetchErrors) {
            return null;
        }
        return (React.createElement(Container, null,
            React.createElement(Notice, { align: "center" },
                React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement("div", null,
                            React.createElement("p", null,
                                this.ssoStore.customer ? mandateOrServicesRequiredTranslation : '',
                                " ",
                                translate('customerNotice.to-continue'),
                                ' ',
                                React.createElement("span", null,
                                    React.createElement("u", null,
                                        React.createElement(Anchor, { url: "", onClick: (event) => this.handleClick(event) }, translate('customerNotice.change-mandate')))),
                                ', ',
                                React.createElement("span", null,
                                    React.createElement("u", null,
                                        React.createElement(Anchor, { url: config.linkExistingMobileUrl, onClick: () => this.sendGaData('Seo olemasolev mobiilinumber') }, translate('customerNotice.link-existing-mobile')))),
                                translate('customerNotice.or'),
                                ' ',
                                React.createElement("span", null,
                                    React.createElement(Anchor, { url: config.joinDiilUrl, onClick: () => this.sendGaData('Liitu Diiliga') }, translate('customerNotice.join-diil'))),
                                '.'))))),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
    }
};
DiilCustomerRequiredNotice = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], DiilCustomerRequiredNotice);
export default DiilCustomerRequiredNotice;
